import { FC } from 'react';
import { urlUtils } from '../../../utils';
import { SecureImg } from './SecureImg';

export const SecureImgDataUrl: FC<React.ImgHTMLAttributes<HTMLImageElement>> = (props) =>
  urlUtils.isDataUrl(props.src) ? <img alt={props.alt} {...props} /> : <SecureImg {...props} />;
